import { useTranslation } from 'next-i18next';
import React from 'react';

import { Avatar, Button } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import SquaredCheck from '~/images/shared/SquaredCheck.svg';

interface Props {
  handleSubmit: () => void;
}

const ApprovalEditModal: React.FC<Props> = ({ handleSubmit }) => {
  const { closeModal } = useModal();
  const { t } = useTranslation('common');
  return (
    <>
      <div className='mb-32 flex w-full flex-col items-center justify-center gap-16'>
        <Avatar
          icon={
            <span className='text-primary-new-10'>
              <SquaredCheck />
            </span>
          }
          size='xlg'
          variant='single'
          className='w-11 bg-surface-30 bg-opacity-5'
        />
        <div className='w-full text-center text-20 font-bold'>
          {t('are-sure-to-save-edits')}
        </div>
      </div>
      <div className='flex items-center justify-center gap-16 '>
        <Button onClick={handleSubmit}>{t('yes')}</Button>
        <Button variant='filled' color='secondary' onClick={() => closeModal()}>
          {t('no')}
        </Button>
      </div>
    </>
  );
};
export default ApprovalEditModal;
